import { render, staticRenderFns } from "./NevronHeader.vue?vue&type=template&id=106225bc&"
import script from "./NevronHeader.vue?vue&type=script&lang=ts&"
export * from "./NevronHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports